import { getAuthHeaders } from "@/shared/api/authHeaders";
import { keysToSnakeCase } from "@/shared/lib/case";
// This file is generated by generate-entities.ts. Please DO NOT edit this file directly.
import type { QueryOptions } from "@/shared/lib/tanstack-query";
import {
  type UseQueryResult,
  useQueries,
  useQuery,
} from "@tanstack/react-query";
import { FreightMatching } from "@x-mile/api-contract";
import type { GetNotificationsParams } from "../model";

export const useGetNotifications = (
  params: GetNotificationsParams,
  options?: QueryOptions<typeof FreightMatching.useGetNotifications>,
): UseQueryResult<FreightMatching.GetNotificationsQueryResult, undefined> => {
  const authHeaders = getAuthHeaders();
  const result = useQuery({
    ...options,
    queryKey: ["getNotifications", keysToSnakeCase(params)],
    queryFn: () =>
      FreightMatching.getNotifications(
        // バックエンド（rails）ではキーがスネークケースになっているため、クエリパラメータをスネークケースに変換する
        keysToSnakeCase(params),
        {
          headers: authHeaders.isOk() ? authHeaders.value : {},
        },
      ),
  });
  return result as UseQueryResult<
    FreightMatching.GetNotificationsQueryResult,
    undefined
  >;
};

export const useMultipleGetNotifications = (
  paramsList: { [key: string | number]: GetNotificationsParams },
  options?: QueryOptions<typeof FreightMatching.useGetNotifications> & {
    sortFunc?: (a: GetNotificationsParams, b: GetNotificationsParams) => number;
  },
): {
  [key: string | number]: UseQueryResult<
    FreightMatching.GetNotificationsQueryResult,
    undefined
  >;
} => {
  const authHeaders = getAuthHeaders();
  const keys = Object.keys(paramsList);
  const sortedKeys = options?.sortFunc
    ? keys.sort((a, b) =>
        options?.sortFunc ? options.sortFunc(paramsList[a], paramsList[b]) : 0,
      )
    : keys;
  const result = useQueries({
    queries: sortedKeys.map((key) => {
      const params = paramsList[key];
      return {
        ...options,
        queryKey: ["getNotifications", keysToSnakeCase(params)],
        queryFn: () =>
          FreightMatching.getNotifications(
            // バックエンド（rails）ではキーがスネークケースになっているため、クエリパラメータをスネークケースに変換する
            keysToSnakeCase(params),
            {
              headers: authHeaders.isOk() ? authHeaders.value : {},
            },
          ),
      };
    }),
  });
  const resultByKeys = Object.fromEntries(
    keys.map((key, i) => [key, result[i]]),
  );
  return resultByKeys as {
    [key: string | number]: UseQueryResult<
      FreightMatching.GetNotificationsQueryResult,
      undefined
    >;
  };
};

// TODO: api-contract側でmockを生成しないことになったので、自前でmockを生成する
// export const useGetNotificationsMock = (
//   params: GetNotificationsParams,
//   options?: QueryOptions<typeof FreightMatching.useGetNotifications>,
// ) => {
//   const [workerStarted, setWorkerStarted] = useState(false);
//   void (async () => {
//     if (!workerStarted) {
//       await FreightMatching.startMockServerWoker(
//         FreightMatching.getGetNotificationsMockHandler(),
//       );
//       setWorkerStarted(true);
//     }
//   })();
//   return useGetNotifications(params, {
//     enabled: workerStarted && options?.enabled,
//   });
// };

// export const useMultipleGetNotificationsMock = (
//   paramsList: { [key: string | number]: GetNotificationsParams },
//   options?: QueryOptions<typeof FreightMatching.useGetNotifications>,
// ) => {
//   const [workerStarted, setWorkerStarted] = useState(false);
//   void (async () => {
//     if (!workerStarted) {
//       await FreightMatching.startMockServerWoker(
//         FreightMatching.getGetNotificationsMockHandler(),
//       );
//       setWorkerStarted(true);
//     }
//   })();
//   return useMultipleGetNotifications(paramsList, {
//     enabled: workerStarted && options?.enabled,
//   });
// };
